import { gradeFromGradYear } from "@/utils/gradeFromGradYear";
import type { StudentsRow } from "../../components/dashboard/Students/StudentsDataTable";

export const buildStudentsRows = (data: any): StudentsRow[] => {
  const rows: StudentsRow[] = [];

  for (const r of data) {
    rows.push({
      _id: r._id,
      name: r.name,
      email: r.email,
      gradeLevel: gradeFromGradYear(r.gradYear),
    });
  }

  return rows;
};
